import PropTypes from "prop-types";

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * Loading placeholder for BaseForm forms: a stack of `sections` cards, each a
 * title bar over a two-column field grid. `className` is forwarded to the root
 * so a caller can constrain the width (e.g. `tw:max-w-7xl`).
 */
const FormSkeleton = ({ sections, className }) => (
  <div className={cn("tw:flex tw:w-full tw:flex-col tw:gap-4", className)}>
    {Array.from({ length: sections }, (_, i) => (
      <Card key={i}>
        <CardHeader>
          <Skeleton className="tw:h-6 tw:w-40" />
        </CardHeader>
        <CardContent>
          <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
            <Skeleton className="tw:h-10 tw:w-full" />
            <Skeleton className="tw:h-10 tw:w-full" />
          </div>
        </CardContent>
      </Card>
    ))}
  </div>
);

FormSkeleton.propTypes = {
  sections: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default FormSkeleton;
